import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* Style */
import "../style/pages/not_found.css";
//@ts-ignore
import { useBaseStore, useLoggedUserStore, useMetadataStore, useModalStore, usePublicUserMenuStore } from "@store/index";
//@ts-ignore
import SearchBoxHome from "@vueEntry/SearchBoxHome.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import SearchMobile from "@vueEntry/SearchMobile.vue";
import { createPinia, mapActions, mapState } from "pinia";
import { defineAsyncComponent, createApp } from "vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import commonModals from "@vueEntry/CommonComponents/CommonModals";
//@ts-ignore
import PublicUserMenu from "@vueEntry/PublicUserMenu.vue";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
var notFoundApp = createApp({
  name: "NotFound",
  components: Object.assign(Object.assign(Object.assign({
    SearchBoxHome,
    SearchMobile,
    BaseBadge,
    PublicUserMenu,
    BaseDropDown,
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }, LanguageIcons), {
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(() => import("@vmodals/ContactAgencyModal"))
  }), commonModals),
  setup() {
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      amdLabels,
      amdIcons,
      listingType,
      openContactModal,
      openAndReturnToCAMS
    } = useContactAgencyModal();
    useTrustpilotWidget();
    var {
      displayPhone,
      phoneLabel,
      phoneViewId,
      showPhone
    } = useShowPhone();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      isLarge
    } = useBreakpoints();
    return {
      isLarge,
      isAppBannerVisible,
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      //Contact agency modal
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      amdLabels,
      amdIcons,
      listingType,
      openContactModal,
      openAndReturnToCAMS,
      //show-phone
      displayPhone,
      phoneLabel,
      phoneViewId,
      showPhone
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({}, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])), mapState(useMetadataStore, ["pageName"])),
  created() {
    this.initPublicUserMenu();
  },
  methods: Object.assign(Object.assign({
    handleInsertionClick
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["logout", "initPublicUserMenu"]))
});
notFoundApp.use(createPinia());
notFoundApp.mount("#not-found-main");